
import _, { before } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DialKeypad from "./kayboard";
import { Dropdown, Menu, Modal, Select, Tooltip } from "antd";
import { useHistory } from 'react-router-dom';
import DialPadContactLists from "./contactlists";
import store from "../../../context/store/store";
import { config } from '../../../base/constant';
import { URInput } from "../../../shared/widgets/input";
import styles from "./scss/dialpadmainicon.module.scss";
import errorimg from "../../../styles/images/smerror.svg";
import { URButton } from "../../../shared/widgets/button";
import callgreen from "../../../styles/images/callred.svg";
import { URCheckBox } from "../../../shared/widgets/checkbox";
import directTransferImg from "../../../styles/images/transfer1.svg";
import consultTransferBtnImg from "../../../styles/images/call-transfer.svg";
import consultTransferImg from "../../../styles/images/transfer2.svg";
import mute from '../../../styles/images/mute.svg';
import unmute from '../../../styles/images/unmute.svg';
import moreopt from "../../../styles/images/moreopt.svg";
import merge from "../../../styles/images/merge.svg";
import flip from "../../../styles/images/flip.svg";
import park from "../../../styles/images/park.svg";
import {
  altRecTimer,
  asrSearchLanguage, audioLanguageChange, check_Ext_valid,
  clearCallTimer,
  dwldCallTranscript,
  filterGrpContact,
  filterSingleStatusInGroup,
  filterUserStatus,
  frameCallProfile,
  frameMultiGroupCall,
  getCurrentCallDetail, groupCurrentUserMute, outputLanguageChange, startCallTime, toastInformation,
  toastMessageCallWindow, volumeDecrease
} from "../../../base/callService/common";
import participant from '../../../styles/images/participant.svg';
import {
  attendedCallTransfer,
  callMergeHandle,
  callrecording, callTransfer, currentCallEnd,
  holdCall, holdCallWithGuid, initiateCall, initiateGroupCall, removeAllnMuteAll, sendAddParticipantToSocket, sendDTMF, sendVideoCallRequest
} from "../../../base/callService/callService";
import { calldetail, callMainPageInterface, callMainWindowState, closeCaptionmeetingState, currentCallDetail } from "../../../models/callModel";
import { URCheckBoxCall } from "../../../shared/widgets/checkBoxForCall/callCheckBox";

import { userUpdateAsrLang } from "../../../base/callService/callsApiService";
import { Types } from "../../../context/action/action";
import { automatedMintsStore, setAddCall, storeActiveLogs, storeHoldTeam, update_Mic_Language, update_Spec_Language } from "../../../base/callService/store_mining";
import SpecificMemberLists from "../callsWidgets/memberList/specificMemberList";
import { SocketChatService } from "../../../base/socketChatService";
import { UserDetails, contacts, initialStateModel } from "../../../models/model";
import { userInfo } from "../../../base/socketChatService/utils";
import { setInitial, storeAudioTranscript } from "../../../base/socketChatService/newChat";
import MemberLists from "../callsWidgets/memberList";
import { uuidv4 } from "../../../base/meetingService/utils/meetingServices";

type CallMainWindowProps = {
  dialpadUI?: any
};
type CallWindowState = {
  isAddCall: boolean,
  isKeyPad: boolean,
  ifFlipKey: string,
  mic_Search: string,
  spec_Search: string,
  transferType: string,
  open_ASR_mic: boolean,
  isModalVisible: boolean,
  isFlippedDevice: string,
  isTransferPopup: boolean,
  open_ASR_speaker: boolean,
  tempAllContacts: Array<any>,
  allContacts: Array<any>,
  searchText: string,
  chooseParticipants: Array<any>
  isEndModal:boolean,
  isAssignModal:boolean,
  isCallFlipped:boolean,
  isGroupCall:boolean,
  isAddCallModal:boolean,
  chooseAddCallPart:Array<any>,
  phNum:any,
  totalPart:any,
  allCon:Array<any>
  tempCon:Array<any>
};

export default function CallMainWindowTeam({ dialpadUI }: CallMainWindowProps) {

  let history = useHistory();
  const [getCallWindow, setCallWindow] = useState<CallWindowState>
    ({
      isAddCall: false,isGroupCall:false, isKeyPad: false, isModalVisible: false,
      isFlippedDevice: '', ifFlipKey: '', mic_Search: '', spec_Search: '',
      transferType: '', open_ASR_mic: false, open_ASR_speaker: false, isTransferPopup: false,isEndModal:false,isAddCallModal:false,
      tempAllContacts: [], allContacts: [], searchText: '', chooseParticipants: [],isAssignModal:false,chooseAddCallPart:[],
      isCallFlipped:false, phNum:[],totalPart:[],tempCon:[],allCon:[]
    });
  const callReducer: currentCallDetail = store.getState().updatedCallList || [];
  const { callPermissionDetail, updatedCallList}: callMainWindowState
    = useSelector((state: callMainWindowState) => state);
  let { flipDeviceInfo } = callPermissionDetail || [];
  let activeCallDetail: any = getCurrentCallDetail();
  const{planBased}= useSelector((state:any) => state.meetingReducer);
  const contactList: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  const workContacts: any = contactList.workContacts;
 // let isActiveCheck: string = updatedCallList.rightSideWindow || '';
  let updatedCallRedux: calldetail[] = updatedCallList.callDetails || [];
  let closeCaption: closeCaptionmeetingState = store.getState().closeCaption || [];
  let connectedGrpUsers:any;
  const { contactReducer }: callMainPageInterface = useSelector((state: callMainPageInterface) => state);
  let workList = contactReducer.workContacts;
  let teamList: Array<any> = contactReducer.teamContacs;
  let searchableContact: Array<any> = workList.concat(teamList);
  let {connectingStatus,bound,callType}=activeCallDetail;
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [callRecordingBtnDisable, setCallRecordingBtnDisable] = useState(false);
  const [groupCallBtnDisable, setGroupCalBtnDisable] = useState(false);

 if(activeCallDetail.isGroupCall){
  connectedGrpUsers= filterUserStatus(activeCallDetail.groupCallInfo,'Connected');

 }
 let { allContacts, tempAllContacts, chooseParticipants, searchText,isCallFlipped } = getCallWindow;

  const openKeypad = () => { setCallWindow({ ...getCallWindow, isKeyPad: !getCallWindow.isKeyPad }); };

  const addAnotherCall = () => {
    setAddCall(true);
    if (dialpadUI) {
      dialpadUI();
    }
  };

  useEffect(() => {
  // {AdvancedCallControls = (More > CallPark, CallFlip), VideoMeetreq, CallTransfer}
    const AdvancedCallControls = planBased.find((item:any) => item.featureid === 54);
    if (AdvancedCallControls && AdvancedCallControls.value1 === "Yes") {
      setIsButtonDisabled(false); 
    } else {
      setIsButtonDisabled(true); 
    }
    // {Call Recording}
    const CallRecording = planBased.find((item:any) => item.featureid === 50);
    if (CallRecording && CallRecording.value1 === "Yes") {
      setCallRecordingBtnDisable(false); 
    } else {
      setCallRecordingBtnDisable(true); 
    }
    // {Add Participants}
    const GroupCallFeature = planBased.find((item:any) => item.featureid === 49);
    if (GroupCallFeature && GroupCallFeature.value1 === "Yes") {
      setGroupCalBtnDisable(false); 
    } else {
      setGroupCalBtnDisable(true);
    }
    
  }, [planBased]); 
  

  const callFlip = () => {
    const socketservice = new SocketChatService(userInfo().fromID, userInfo().domainId);
    let {activeLogs}= store.getState().callReducer||{};
    let {filpcallConnected}= store.getState().callReducer||{};
    let activeCallDetail: any = getCurrentCallDetail();
//console.log(socketservice,"socketservice");
    setCallWindow({
      ...getCallWindow, isModalVisible: !getCallWindow.isModalVisible,
      isFlippedDevice: '', ifFlipKey: '',isCallFlipped:true
    });
    socketservice.getFlipCall(filpcallConnected.toCallId
      ,activeCallDetail.caller_id,filpcallConnected.to,filpcallConnected.fromDeviceType,filpcallConnected.uid,filpcallConnected.from);
      toastInformation('Call Flipped','success')
  };

  const callPark = () => {
    sendDTMF('*88#');
  };

  const setTranscribe = () => {
    setCallWindow({ ...getCallWindow, open_ASR_speaker: !getCallWindow.open_ASR_speaker });
  };

  const transferCall = (option: string) => {
    setCallWindow({ ...getCallWindow, isGroupCall: true, transferType: option, isTransferPopup: false });
    if (dialpadUI) {
      dialpadUI();
    }
  }

  const contactListHide = () => {
    setCallWindow({ ...getCallWindow, isGroupCall: false });
    if (dialpadUI) { dialpadUI(); }
  };

  const selectedContactList = (ext: string, selectedContactName: string) => {
    if (ext !== "" && check_Ext_valid(ext)) {
      if (getCallWindow.transferType !== '') {
        if (getCallWindow.transferType === 'blind') {
          callTransfer(ext);
          toastShow(config().CALL_TRANSFER);
        }

        else if(getCallWindow.transferType === 'consult'){

          initiateCall(ext, 'audio', 'consult');

        }
        else { 
          

        store.dispatch({
          type: Types.TEAM_CALL_HOLD,
          payloads: {
            isTeamCallHold :true ,
            isTeamHoldNum : ext
          }      
      });
    
    }
        setCallWindow({ ...getCallWindow, isGroupCall: false, transferType: '' });
        if (dialpadUI) { dialpadUI(); }
      }
      else {
        let exts=[];
        exts.push(ext)
        sendAddParticipantToSocket(exts,'');
        setCallWindow({ ...getCallWindow, isGroupCall: false });
        // initiateCall(ext, 'audio');
        // setCallWindow({ ...getCallWindow, isAddCall: false });
        // toastShow(config().ADD_CALL + " " + selectedContactName);
      }
    }
    else { toastShow("Please check the number"); }
    if (dialpadUI) {
      dialpadUI();
    }
  };

  const attendedCallTransferOpt = () => {
    attendedCallTransfer();
    toastShow(config().CALL_TRANSFER);
  };

  const toastShow = (message: string, timer?: number) => {
    if (history.location.pathname === '/calls' && !updatedCallList.minimizedWindow) { toastMessageCallWindow(message, timer); }
    else { toastInformation(message, "success"); }
  };

//   const callFlipped = () => {
//  ///  let {filpcallConnected,activeLogs}= store.getState().callReducer||{};
//    ///let activeCallDetail: any = getCurrentCallDetail();
//    console.log(activeCallDetail,"activeCallDetail1111");
   

//   ///  const socketservice = new SocketChatService(userInfo().fromID, userInfo().domainId);
//     if (getCallWindow.ifFlipKey) {
//       sendDTMF(getCallWindow.ifFlipKey);
//       let deviceType: string = '';
//       deviceType = (getCallWindow.isFlippedDevice === config().DESK_PHONE) ? 'Desk Phone' :
//         (getCallWindow.isFlippedDevice === config().UR_ANDROID) ? 'Android' : 'IOS';
//       toastShow("Call flip to " + deviceType + " Device");
//     }
//     setCallWindow({
//       ...getCallWindow, isModalVisible: !getCallWindow.isModalVisible,
//       isFlippedDevice: '', ifFlipKey: ''
//     });
//  ///socketservice.getFlipCall(filpcallConnected.uid,filpcallConnected.toDeviceType,filpcallConnected.from,activeCallDetail.caller_id)
//   };
const callFlipped = () => {
   
  //console.log("activeLogsuiuiohh",activeLogs.guid);
  
   const socketservice = new SocketChatService(userInfo().fromID, userInfo().domainId);
  //  let {activeLogs}= store.getState().callReducer||{};
  //  let {filpcallConnected}= store.getState().callReducer||{};
  //  console.log("filpcallConnected111",filpcallConnected);
   
  //  console.log("activeLogsuiuiohh",activeLogs);
  // let activeCallDetail: any = getCurrentCallDetail();
  // console.log(activeCallDetail,"activeCallDetail1111");
  

   
  
   if (getCallWindow.ifFlipKey) {
   //  sendDTMF(getCallWindow.ifFlipKey);
     let deviceType: string = '';
     deviceType = (getCallWindow.isFlippedDevice === config().DESK_PHONE) ? 'Desk Phone' :
       (getCallWindow.isFlippedDevice === config().UR_ANDROID) ? 'Android' : 'IOS';
     toastShow("Call flip to " + deviceType + " Device");
   }
   setCallWindow({
     ...getCallWindow, isModalVisible: !getCallWindow.isModalVisible,
     isFlippedDevice: '', ifFlipKey: ''
   });

//socketservice.getFlipCall(activeCallDetail.guid,activeCallDetail.caller_id,activeCallDetail.from,filpcallConnected.fromDeviceType);

 };
  const flipDeviceChecked = (status: string, key: string) => {
    setCallWindow({ ...getCallWindow, isFlippedDevice: status, ifFlipKey: key });
  };

  const updateInputLanguage = (lanChar: string) => {
    update_Mic_Language(lanChar);
    setCallWindow({ ...getCallWindow, open_ASR_mic: false });
    audioLanguageChange(lanChar, activeCallDetail.guid);
  };

  const updateOutputLanguage = (lanChar: string) => {
    update_Spec_Language(lanChar);
    setCallWindow({ ...getCallWindow, open_ASR_speaker: false });
    if (lanChar === 'en' || lanChar === 'es' || lanChar === 'fr') {
      (lanChar === 'en' ? volumeDecrease(1) : volumeDecrease(0));
      outputLanguageChange(lanChar, activeCallDetail.guid);
    }
  };
  const textBoxMicOnchange = (keyPress: any) => {
    setCallWindow({ ...getCallWindow, mic_Search: keyPress.target.value });
  };

  const textBoxSpecOnchange = (keyPress: any) => {
    setCallWindow({ ...getCallWindow, spec_Search: keyPress.target.value });
  };

  const callRecordStartStop = () => {
    if(activeCallDetail['autoRecord'] !== true){
    if (activeCallDetail['onDemand'] === true) {
      (activeCallDetail['recordState']) ? toastShow('Call recorded stopped') : toastShow('Call recording started');
      sendDTMF("*9");
      callrecording();
    }
    else { toastShow('Please enable recording option in my account...'); }
  }
  else{
    toastShow("we cant allow to stop recording auto record is on")
  }
  };
  const consultTransferDropDown = (
    <div className={styles.transferpops}>
      <ul>
        <li onClick={() => transferCall('blind')}>
          <img src={directTransferImg} alt="" />Direct Call Transfer</li>
        <li onClick={() => transferCall('consult')}>
          <img src={consultTransferImg} alt="" />Attend Call Transfer</li>
      </ul>
    </div>
  );

  let ASR_Data: any = store.getState().ASR_Language || [];
  let asrMicLanguage = asrSearchLanguage(ASR_Data.list, getCallWindow.mic_Search);
  let asrSpecLanguage = asrSearchLanguage(ASR_Data.list, getCallWindow.spec_Search);
  let ast_default_Mic_Opt = ASR_Data.asr_mic_lan || 'en';
  let ast_default_Spe_Opt = ASR_Data.asr_speaker_lan || 'en';

  const inputLangSelection = (
    <div className={styles.autoTranslateLangs}>
      <h3>Speaking Language</h3>
      <div className={styles.searchBox}><URInput placeHolder='Search'
        className='searchBoxlanglist' onChange={textBoxMicOnchange} /></div>
      <ul className={`scroller ${styles.langList}`}>
        {asrMicLanguage.map((elem: any, index: number) => {
          return (<li key={index} className={ast_default_Mic_Opt === elem.languageCode ? `${styles.selected} ${styles.active}` : styles.selected}
            onClick={() => updateInputLanguage(elem.languageCode)}>
            <span className={ast_default_Mic_Opt === elem.languageCode ? `icon_tick  ltick` : 'icon_tick'}></span>
            {elem.languageName + " (" + elem.languageCode + ")"}</li>);
        })
        }
      </ul>
      <div className={`customchecksize ${styles.bottomFooterSec}`}>
        <URCheckBox onChange={(e: any) => update_ASR_Language(e)} />
        <span className={styles.saveTxttop}>Save for future</span>
      </div>
    </div>
  );

  const outPutLangSelection = (
    <div className={styles.autoTranslateLangs}>
      <h3>Audio Translation Language</h3>
      <div className={styles.searchBox}><URInput placeHolder='Search'
        className='searchBoxlanglist' onChange={textBoxSpecOnchange} /></div>
      <ul className={`scroller ${styles.langList}`}>
        {asrSpecLanguage.map((elem: any, index: number) => {
          return (<li key={index} className={ast_default_Spe_Opt === elem.languageCode ? `${styles.selected} ${styles.active}` : styles.selected}
            onClick={() => updateOutputLanguage(elem.languageCode)}>
            <span className={ast_default_Spe_Opt === elem.languageCode ? `icon_tick  ltick` : 'icon_tick'}></span>
            {elem.languageName + " (" + elem.languageCode + ")"}</li>);
        })
        }
      </ul>
      <div className={`customchecksize ${styles.bottomFooterSec}`}>
        <URCheckBox onChange={(e: any) => update_ASR_Language(e)} />
        <span className={styles.saveTxttop}>Update in My Profile Settings</span>
      </div>
    </div>
  );

  const update_ASR_Language = (e: any) => {
    if (e.target.checked) {
      let data: any = {
        languageCode: (getCallWindow.open_ASR_mic) ? ast_default_Mic_Opt : ast_default_Spe_Opt
      };
      userUpdateAsrLang(data);
    }
    setCallWindow({ ...getCallWindow, open_ASR_mic: false, open_ASR_speaker: false });
  };
  const handle_Mic_VisibleChange = (flag: any) => {
    setCallWindow({ ...getCallWindow, open_ASR_mic: flag });
  };
  const handle_Spec_VisibleChange = (flag: any) => {
    setCallWindow({ ...getCallWindow, open_ASR_speaker: flag });
  };
  const handle_Transfer_VisibleChange = (flag: any) => {
    setCallWindow({ ...getCallWindow, isTransferPopup: flag });
  };

  const open_Mic_Speaker_Keyword = (status: string) => {
    if (status === 'mic') {
      setCallWindow({ ...getCallWindow, open_ASR_mic: true });
    }
    else {
      setCallWindow({ ...getCallWindow, open_ASR_speaker: true });
    }
  };
  const get_Default_Asrlanguage = () => {
    let language: any = _.find(ASR_Data.list, { languageCode: ast_default_Spe_Opt }) || [];
    return language?.languageName || 'english';
  };
  const transcript_Open = () => {
    if (closeCaption.localStreaming === "stopped") {
      audioLanguageChange(ast_default_Mic_Opt, activeCallDetail.guid);
    }
    if (history.location.pathname !== 'calls') {
      history.push('/calls');
      setTimeout(function () {
        automatedMintsStore('transcript', 'callList', 'Transcription');
      }, 100)
    }
    else { automatedMintsStore('transcript', 'callList', 'Transcription'); }
  };

  const MOM_Open = () => {
    if (history.location.pathname !== 'calls') {
      history.push('/calls');
      setTimeout(function () { automatedMintsStore('summary', 'callList', 'MOM'); }, 100)
    }
    else { automatedMintsStore('summary', 'callList', 'MOM'); }
  };

const cancelEndModal=()=>{
  setCallWindow({ ...getCallWindow,  isEndModal: false });
}

const onLeave=()=>{
  let {activeLogs}= store.getState().callReducer||{};
    activeLogs.map((e: any) => {
      if (e.guid === activeCallDetail.guid) {
         e.callStatus = 'Rejoin'
        }
    });
  storeActiveLogs(activeLogs);
  currentCallEnd();
  // storeAudioTranscript([],true,false);
  if(closeCaption.autoDwld){dwldCallTranscript()}
}

const beforeLeave=()=>{ 
  let connectedUsers: Array<any> = filterSingleStatusInGroup(activeCallDetail.groupCallInfo, 'Connected',activeCallDetail.isHostId);
    setCallWindow({ ...getCallWindow, allContacts: connectedUsers, tempAllContacts: connectedUsers, isAssignModal:true }); 
  
};


  const onEnd = () => {
    if (activeCallDetail.isGroupCall) {

      if (activeCallDetail.isGroupHost) {
        let connectedUsers: Array<any> = filterSingleStatusInGroup(activeCallDetail.groupCallInfo, 'Connected', activeCallDetail.isHostId);
        if (connectedUsers.length >= 1 ) {
          setCallWindow({ ...getCallWindow, allContacts: connectedUsers, tempAllContacts: connectedUsers, isEndModal: true });
        }
        else {
          
          endAllCall();
        }
      }
      else {
        onLeave();
        
      }
    }
    else {
      currentCallEnd();
      
    }
  }


const change = (val: any, obj: any) => {
  let connectedUsers: Array<any> = filterSingleStatusInGroup(activeCallDetail.groupCallInfo, 'Connected',activeCallDetail.isHostId);
    setCallWindow({
    ...getCallWindow, chooseParticipants: val,
    allContacts: connectedUsers
  });

};


const assigNleave=()=>{
  if(chooseParticipants.length===0){ return  toastInformation('No users selected','warning')}
  onLeave();
  let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
  const socketservice = new SocketChatService(loggeduser.sip_login_id, loggeduser.domain_id);
  let data:any={};
  socketservice.updateGroupCallHost(activeCallDetail.guid, (chooseParticipants).toString());
    data.TeamID=activeCallDetail.guid;
    data.Status="AssignAndLeave";
    data.AssignedHost= (chooseParticipants).toString();
    data.DomainName=loggeduser.domain_name;
    data.CurrentHost=activeCallDetail.isHostId;
    data.DomainId=loggeduser.domain_id;
    socketservice.groupCallSendEvent(data);
  setCallWindow({
    ...getCallWindow, isEndModal: false
  });

  
}

const openAddCall=()=>{
  setCallWindow({...getCallWindow,isAddCallModal:true,allCon:searchableContact,tempCon:searchableContact});
}

const closeAssign =()=>{
  setCallWindow({
    ...getCallWindow, isAssignModal: false,chooseParticipants:[],allContacts:[],tempAllContacts:[]
  });
}

const menu = (
  <Menu>
    <Menu.Item  onClick={callPark} disabled ={isButtonDisabled} style={isButtonDisabled ? { cursor: 'default', color: '#ccc' } : {}}> 
      <img src={park} className={isButtonDisabled ? 'disabled-img' : ''}></img>Park</Menu.Item>
    <Menu.Item onClick={callFlip} disabled = {isButtonDisabled} style={isButtonDisabled ? { cursor: 'default', color: '#ccc' } : {}}> 
      <img src={flip} className={isButtonDisabled ? 'disabled-img' : ''}></img>Flip</Menu.Item>
  </Menu>
);


const searchContact = (e: any) => {
  let searchName = e.toLowerCase();

  if (searchName !== "") {
    let filtered = _.filter(tempAllContacts, function (name: any) {
      return name.caller_id?.toLowerCase().includes(searchName) ||
        name.ext?.toString().includes(searchName) || name.team_name?.toLowerCase().includes(searchName);
    });
    setCallWindow({ ...getCallWindow, allContacts: filtered, searchText: searchName });
  }
  else { setCallWindow({ ...getCallWindow, allContacts: tempAllContacts, searchText: '' }); }
}


const endAllCall=()=>{
  removeAllnMuteAll('RemoveAll',activeCallDetail.guid);
  currentCallEnd();
  // storeAudioTranscript([],true,false);
  if(closeCaption.autoDwld){dwldCallTranscript()}
  clearCallTimer();
  // handleEndModal();
}


const muteBtnClk = () => { groupCurrentUserMute(); }
  let disableIcon: any = [];
  if(activeCallDetail.isGroupCall){    
    if(connectedGrpUsers.length>0){
     if(activeCallDetail.isGroupHost) {
      disableIcon=['addVideo','recording', 'transfer', 'flip', 'park', 'transcript', 'mom', 'trancsribe'];
     }else{
      disableIcon=['addVideo','recording', 'transfer', 'flip', 'park', 'transcript', 'mom', 'trancsribe'];
     }
    }
    else{
      disableIcon= ['addVideo', 'hold', 'recording', 'transfer', 'flip', 'park', 'transcript', 'mom', 'trancsribe']; }
  }
  else{
    disableIcon = activeCallDetail.connectingStatus==='Attended'?[]:['addCall','addVideo', 'hold', 'recording', 'transfer', 'flip', 'park', 'transcript', 'mom', 'trancsribe']  ;
 
  }
  // if (updatedCallRedux.length === 2 && !activeCallDetail.consult) {
  //   showIcon = [];
  // }
  // else if (conferenceDetails.isConference && !conferenceDetails.isNewCall) {
  //   showIcon = ['mute','addCall'];
  // }
  //storeDisable.indexOf('hold') !== -1 ? true :false

  const changePart = (val: any, obj: any) => {
    let allUsers:Array<any>=[];
    val.map((key: any) => {
     let keyStr = key.toString();
     if (keyStr.includes('con')) {
       let groupId: string = keyStr.replace('con', '');
      let {members}:any = filterGrpContact((groupId), false);
      allUsers.push(...Object.keys(members))
     }
     else{
       allUsers.push(keyStr)
     }
  
   })
   allUsers.push(...getCallWindow.phNum)
   if(allUsers.length<=100){
    setCallWindow({...getCallWindow,chooseAddCallPart:val,totalPart:allUsers})

   }
   else{
     toastInformation('Maximum participants reached','warning')
   }
  

 };

  const addCallClose=()=>{
    setCallWindow({...getCallWindow,isAddCallModal:false, allContacts: tempAllContacts, searchText: '',phNum:[],chooseAddCallPart:[],totalPart:[]})
  }

  const handleNumbers = (value: any) => {
    let allUsers:any = [];
    if(getCallWindow.totalPart.length>0&& getCallWindow.phNum.length>0){
      getCallWindow.phNum.map((user:any)=>{
       let userIndex: number = getCallWindow.totalPart.indexOf(user);
       if(userIndex!==-1){
        getCallWindow.totalPart.splice(userIndex,1)
       }
     })}
    allUsers.push(...value, ...getCallWindow.totalPart)

    if (allUsers.length <= 100) {
      setCallWindow({ ...getCallWindow, phNum: value, totalPart: allUsers });
    }
    else {
      toastInformation('Maximum participants reached', 'warning')
    }
  }

  const startTeamCall = () => {
    let totalUser: Array<any> = getCallWindow.chooseAddCallPart.concat(getCallWindow.phNum);
    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
    console.log(currentCallList,"currentCallList++++++");
    let activeCallDetail: any = getCurrentCallDetail();

    let alreadycurrencalllist :any = activeCallDetail?.groupCallInfo?.GroupDetails;
    let alreadycurrentIndividualCalllist :any = activeCallDetail?.groupCallInfo?.IndividualDetails;
    console.log(alreadycurrentIndividualCalllist,"alreadycurrentIndividualCalllist===");
    let alreadycurrentPstnlist :any = activeCallDetail?.groupCallInfo?.PSTNDetails;

    let disconnectedUser:any;
    Object.entries(alreadycurrentIndividualCalllist).forEach(([key, user]:any) => {
      if (user.callStatus === "Disconnected") {
        disconnectedUser = user;
      }
    });


    let getCurrentCallList:any;
    let getCurrentindividualCallList:any;
    let getCurrentPstnList:any;
    let keysvale = Object.keys(alreadycurrencalllist);
    keysvale.forEach((data)=>{
      getCurrentCallList = alreadycurrencalllist[data];
    })

    let pstnkeysvale = Object.keys(alreadycurrentPstnlist);
    pstnkeysvale.forEach((data)=>{
      getCurrentPstnList = alreadycurrentPstnlist[data];
    })

    getCurrentindividualCallList = alreadycurrentIndividualCalllist;
    let matchedCurrentList: any = getCallWindow.chooseAddCallPart.find((x: any) =>  !getCurrentCallList || !getCurrentCallList[x]);

    let matchedCurrentIndividualList :any =getCallWindow.chooseAddCallPart.find((x: any) =>  !getCurrentindividualCallList || !getCurrentindividualCallList[parseInt(x)]);

          let matchedCurrentPstnList : any =getCallWindow.chooseAddCallPart.find((x: any) =>  !getCurrentPstnList || !getCurrentPstnList[x]);
        // let matchedCurrentPstnList : any =getCallWindow.phNum.find((x: any) =>  !getCurrentPstnList || !getCurrentPstnList[x]);
        let makeGroupCall:boolean=totalUser.length>1?true:( (totalUser[0].toString()).includes('con')?true:false);
        let userData:any = frameCallProfile(getCurrentCallDetail()||{});
     
  if(matchedCurrentPstnList ===undefined ||  (getCallWindow.chooseAddCallPart.toString() === disconnectedUser?.ext.toString()) || (matchedCurrentList !== undefined && matchedCurrentIndividualList  !== undefined && getCallWindow.chooseAddCallPart.toString() !== userData.ext.toString())){
    if(totalUser.length>0 ){
    if(_.isEmpty(callReducer.callDetails) ){
      makeGroupCall? initiateGroupCall('multi', getCallWindow.chooseAddCallPart, getCallWindow.phNum):initiateCall(totalUser[0],'audio');
    }else{ 
    if(callReducer.callDetails[0].holdState === true){
      makeGroupCall? initiateGroupCall('multi', getCallWindow.chooseAddCallPart, getCallWindow.phNum):initiateCall(totalUser[0],'audio');
    }
      else{
      if (makeGroupCall) { storeHoldTeam(true, 'Group', getCallWindow.chooseAddCallPart, getCallWindow.phNum) }
      else {
        storeHoldTeam(true, 'Normal', totalUser[0]) }

    }
  }
}}
else {
    toastInformation("you are already in a call.");
  }
  closeTeamCall()
}

const closeTeamCall = () => {
  setCallWindow({ ...getCallWindow, chooseAddCallPart: [], phNum: [] ,totalPart:[],isAddCallModal:false,searchText:"",allContacts: tempAllContacts});
}

const searchAddCall=(e:any)=>{

    let searchName = e.toLowerCase();

    if (searchName !== "") {
      let filtered = _.filter(getCallWindow.tempCon, function (name: any) {
        return name.caller_id?.toLowerCase().includes(searchName) ||
          name.ext?.toString().includes(searchName) || name.team_name?.toLowerCase().includes(searchName);
      });
      setCallWindow({ ...getCallWindow, allCon: filtered, searchText: searchName });
    }
    else { setCallWindow({ ...getCallWindow, allCon: getCallWindow.tempCon, searchText: '' }); }

}
  const holdCallswp = () =>{
    if(activeCallDetail.isCurrent){
      holdCallWithGuid(activeCallDetail.guid);}
    else{
      holdCall();}}

const videoCallRequest = ()=>{

  console.log("Video call request calling", activeCallDetail.contact);
  sendVideoCallRequest(activeCallDetail.contact)

}

const mergeCalls = () => {
  let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
  const socketservice = new SocketChatService(loggeduser.sip_login_id, loggeduser.domain_id);
  let allCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
  let groupIndex: number = _.findIndex(allCallList, { isGroupCall: true });
  let groupArr:any=  allCallList
  .filter((value: any) => value.isGroupCall === true);
  let internalUsers: any = [];
  let externalUsers: any = [];
  let MergeCall_id:any = [];
  let userNum: any = [];
  let framed: any = {};
  let Exten: any = [];
  let teamID: any = '';
  let MergerequestId: any = '';
  if (groupIndex === -1) {
    allCallList.map((list: any)=>{
      if(list.contact?.ext !== undefined && list?.contact !== undefined ){
        Exten.push(list.contact?.ext?.toString());
        }
      MergeCall_id.push(list['bound'] === "OUT"? list['switchCallId']:list.guid);
      teamID = uuidv4();

      
      if (list.callStatus === "Active"){
        MergerequestId =  list['bound'] === "OUT"? list['switchCallId']:list.guid
      }        
      userNum  = list.to === loggeduser.ext ? list.from : list.to;
      userNum.length > 3 ? externalUsers.push(userNum) : internalUsers.push(userNum);        
    })       
    framed.TeamID = teamID;
    framed.Status = "MergeToGroup";
    framed.Host = loggeduser.ext.toString();
    framed.Pstns = externalUsers;
    framed.MergeRequestId = MergerequestId;
    framed.Extensions = Exten;
    framed.DomainName = loggeduser?.domain_name;
    framed.DomainId = loggeduser.domain_id.toString();
    framed.MergeCallIds = MergeCall_id;      

    socketservice.mergeCallSendEvent(framed)
    // let externalUsers: any = [];
    // allCallList?.map((calls: any) => {
    //   let userNum: any = calls.to === loggeduser.ext ? calls.from : calls.to;
    //   userNum.length > 3 ? externalUsers.push(userNum) : internalUsers.push(userNum);
    // })
    // internalUsers.push(loggeduser.ext)
    // let guid = uuidv4();
    // framed = frameMultiGroupCall(guid, 'Merge', internalUsers, externalUsers);
    // socketservice.groupCallSendEvent(framed.header)

  }
  else if(groupArr?.length > 1){
    toastInformation('Two group calls cannot be merged', 'warning')
  }
  else {
    if (allCallList[groupIndex]?.isGroupHost) {
      allCallList?.map((calls: any) => {
        let userNum: any = calls.to === loggeduser.ext ? calls.from : calls.to;
          userNum.length > 3 ? externalUsers.push(userNum) : internalUsers.push(userNum);
      })
      setInitial(false);
      framed = frameMultiGroupCall(allCallList[groupIndex].guid, 'Merge', internalUsers);
      socketservice.groupCallSendEvent(framed.header)
    }
    else {
      toastInformation('Only Host can merge the call', 'warning')
    }
  }


};

let enableOptions:boolean=connectingStatus==='Attended'&&callType!=='conference';
  return (
    <>
      <div className={`${styles.dialscreens} ${styles.forteamdialscreen}`}>
        {(!getCallWindow.isKeyPad && !getCallWindow.isGroupCall) &&
          <>
            <div className={`${styles.chatDialPadInner}`}>
              <div className={`${styles.chatDialPadNumber} ${activeCallDetail.muteState ? styles.active : ''}`}>
                {activeCallDetail.muteState ? <img src={unmute} className= "unmutebig" 
                  onClick={muteBtnClk}>
                  </img>:
                    <img src={mute} className="unmuteiconimg" onClick={muteBtnClk}></img>}
                <Dropdown placement="bottomRight"
                  overlay={inputLangSelection} trigger={['click']}
                  onVisibleChange={handle_Mic_VisibleChange}
                  visible={getCallWindow.open_ASR_mic}>
                  <span className={`dialiconlists ${"icon_down-arrow"} ${styles.insidearrow}`}
                    onClick={() => open_Mic_Speaker_Keyword('mic')}></span>
                </Dropdown>

                {/* <img src={errorimg} className={styles.errors} alt="" /> */}
                <div className={styles.tooltips}>{activeCallDetail.muteState ? 'Unmute' : 'Mute'}</div></div>
            </div>
          {updatedCallList.minimizedWindow && updatedCallList.callDetails.length===1?
           <>
           <div className={`${styles.chatDialPadInner} ${disableIcon.indexOf('hold') !== -1 ? styles.disabledIcon : ''}`}
             onClick={holdCall}>
             <div className={`${styles.chatDialPadNumber} ${activeCallDetail.holdState ? styles.active : ''}`}>
               <span className={activeCallDetail.holdState ? "icon_holdfill" : 'icon_holdoutline'}></span>
               <div className={styles.tooltips}>{activeCallDetail.holdState ? "Unhold" : 'Hold'}</div></div>
           </div>
         </>
            : 
             <>
             <div className={`${styles.chatDialPadInner} ${disableIcon.indexOf('keypad') !== -1 ? styles.disabledIcon : ''}`} onClick={openKeypad}>
               <div className={styles.chatDialPadNumber}><span className="icon_Keypadoutline"></span>
                 <div className={styles.tooltips}>Keypad</div></div>
             </div>
           </>}


            <div className={`${styles.chatDialPadInner} ${disableIcon.indexOf('addVideo') !== -1 || isButtonDisabled ?styles.disabledIcon: ''}`}
             onClick={() => videoCallRequest()}>
             <div className={styles.chatDialPadNumber}><span className="icon_meet"></span>
               <div className={styles.tooltips}>Meet</div></div>
           </div>
{
             
              (updatedCallRedux.length >= 2&&activeCallDetail.connectingStatus==='Attended') ?  <div className={`${styles.chatDialPadInner} ${disableIcon.indexOf('mergeCall') !== -1 ?styles.disabledIcon: ''}`  } onClick={mergeCalls}>
              <div className={styles.chatDialPadNumber}><span><img src={merge}></img></span>
                <div className={styles.tooltips}>Merge Call</div></div>
            </div> :   <div className={`${styles.chatDialPadInner} ${disableIcon.indexOf('addCall') !== -1 ?styles.disabledIcon: ''}`  } onClick={openAddCall}>
              <div className={styles.chatDialPadNumber}><span className="icon_dialplus"></span>
                <div className={styles.tooltips}>Add Call</div></div>
            </div>
              
             
}
            {/* {!(updatedCallList.minimizedWindow && updatedCallList.callDetails.length===1)&&
           <div className={`${styles.chatDialPadInner} ${disableIcon.indexOf('addCall') !== -1 ?styles.disabledIcon: ''}`  } onClick={openAddCall}>
              <div className={styles.chatDialPadNumber}><span className="icon_dialplus"></span>
                <div className={styles.tooltips}>Add Call</div></div>
            </div>} */}
          {!(updatedCallList.minimizedWindow && updatedCallList.callDetails.length===1)&&
            <div className={`${styles.chatDialPadInner} ${disableIcon.indexOf('hold') !== -1 ? styles.disabledIcon : ''}`}
              onClick={holdCall}>
              <div className={`${styles.chatDialPadNumber} ${activeCallDetail.holdState ? styles.active : ''}`}>
                <span className={activeCallDetail.holdState ? "icon_holdfill" : 'icon_holdoutline'}></span>
                <div className={styles.tooltips}>{activeCallDetail.holdState ? "Unhold" : 'Hold'}</div></div>
            </div>}
            {
              !(updatedCallList.minimizedWindow && updatedCallList.callDetails.length===1)&&
              <div className={`${styles.chatDialPadInner} ${disableIcon.indexOf('hold') !== -1 || groupCallBtnDisable ? styles.disabledIcon : ''}`} onClick={addAnotherCall} >
                 {/* <div className={`${styles.chatDialPadNumber} ${activeCallDetail.holdState ? styles.active : ''}`}> */}
                <div className={`${styles.chatDialPadNumber}`}>
                  <span><img src={participant}></img></span>
                  <div className={styles.tooltips}>Add Participants</div></div>
              </div>
            }

            {!(updatedCallList.minimizedWindow && updatedCallList.callDetails.length===1)&&
            <div className={`${styles.chatDialPadInner} 
            ${disableIcon.indexOf('transfer') !== -1 || isButtonDisabled ? styles.disabledIcon:''}`}>
              <div className={`${styles.chatDialPadNumber} ${(getCallWindow.isTransferPopup) ? styles.active : ''}`}>
                <Dropdown overlay={consultTransferDropDown} placement="bottomLeft" trigger={['click']}
                  onVisibleChange={handle_Transfer_VisibleChange}
                  visible={getCallWindow.isTransferPopup}
                ><span className="icon_transferoutline"></span>
                </Dropdown>
                <div className={styles.tooltips}>Transfer</div>
              </div>
          </div>}
          <div className={`${styles.chatDialPadInner} ${disableIcon.indexOf('recording') !== -1 || callRecordingBtnDisable ?  styles.disabledIcon:''}
            ${activeCallDetail.recordState && connectingStatus === "Attended" && styles.recordenable}`}
              onClick={callRecordStartStop}>
              <div className={`${styles.chatDialPadNumber} ${activeCallDetail.recordState && styles.recordStart}`}>
              <span className={`icon_recordoutline ${callRecordingBtnDisable ? 'disabled-img' : ''}`}></span>
                <div className={styles.tooltips}>{activeCallDetail.recordState ? 'Stop' : 'Recording'}</div>  
                {activeCallDetail.recordState && connectingStatus === "Attended" && 
                !(disableIcon.indexOf('recording') !== -1 || callRecordingBtnDisable) && (
               <span className={styles.recordtime}>{altRecTimer(activeCallDetail?.recordDuration)}</span>
    )}

              </div>
            </div>
<>
          {
              !(updatedCallList.minimizedWindow && updatedCallList.callDetails.length===1)&&
              <Dropdown overlay={menu}>
              {/* <div className={`${styles.chatDialPadInner} ${disableIcon.indexOf('hold') !== -1 || (planBased?.Advanced_call_controls === "No") ? styles.disabledIcon : ''}`}> */}
              <div className={`${styles.chatDialPadInner}  ${ activeCallDetail?.isGroupCall === true || isButtonDisabled ? styles.disabledIcon : ''}`}>
                {/* <div className={`${styles.chatDialPadNumber} ${activeCallDetail.holdState ? styles.active : ''}`}> */}
                <div className={`${styles.chatDialPadNumber}`}>
                  <span><img src={moreopt}></img></span>
                  <div className={styles.tooltips}>More</div></div>
              </div>
              </Dropdown>
            }
          </>
          {/* <div className={`${styles.chatDialPadInner} 
            ${disableIcon.indexOf('flip') !== -1 ?styles.disabledIcon:''}`} onClick={callFlip}>
              <div className={ `${styles.chatDialPadNumber} ${isCallFlipped===true?styles.chatDialPadNumberActive:''}`}><span className="icon_flipoutline"></span>
              <div className={styles.tooltips}>Flip</div></div>
          </div>
          <div className={`${styles.chatDialPadInner} ${disableIcon.indexOf('park') !== -1 ?  styles.disabledIcon:''}`}
            onClick={callPark}>
              <div className={styles.chatDialPadNumber}><span className="icon_parkcall"></span>
                <div className={styles.tooltips}>Park</div></div>
            </div> 
             */}
          {/*     updatedCallList.callDetails.length > 1 &&  
                    <div className={`${styles.chatDialPadInner} ${!activeCallDetail.isGroupCall?styles.disabledIcon: ''}` }
                      onClick={addAnotherCall}>
                      <div className={styles.chatDialPadNumber}><span className="icon_dialplus"> Merge</span>
                      <div className={styles.tooltips}>Merge</div></div>
                </div>  */}
         
          
            {(updatedCallRedux.length === 2 &&activeCallDetail.connectingStatus==='Attended') ?
              (activeCallDetail.consult ?
                (
                  <div className={styles.chatDialCall}>
                    <img src={consultTransferBtnImg} alt="" onClick={attendedCallTransferOpt} />
                    <div className={styles.tooltips}>Complete transfer</div>
                  </div>
                )
                :
                (
                  // <div className={styles.chatDialCall}>
                  //   {/* <img src={mergeCall} alt="" onClick={callMergeHandle} />
                  //   <div className={styles.tooltips}>Merge to conference</div> */}
                  // </div>

                  <div className={`${styles.chatDialCall} ${'chatDialCallred'}`}>
                  <img src={callgreen} alt="" onClick={onEnd} />
                  </div>
                )
              )
              :
              ( 
                <div className={`${styles.chatDialCall} ${'chatDialCallred'}`}>
                  <img src={callgreen} alt="" onClick={onEnd} />
                </div>
               )
            } 

          </>
        }
        {getCallWindow.isKeyPad &&
          <>
            <DialKeypad></DialKeypad>
            <div className={styles.chatDialCall}>
              <img src={callgreen} alt="" onClick={onEnd} />
              <p className={styles.hidesection} onClick={openKeypad}>Hide</p>
            </div>
          </>
        }
        {getCallWindow.isGroupCall &&
          <>
            <DialPadContactLists contactBackEvent={contactListHide}
              selectedContact={selectedContactList} dialpadUI={dialpadUI}
              transferType={getCallWindow.transferType === '' ? 'Add Call' : 'Transfer'}></DialPadContactLists>
          </>
        }
      </div>

      {/* <Modal visible={getCallWindow.isModalVisible} className={`${styles.flipcallmodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={callFlip} />
        <h2>Flip Call</h2>
        {flipDeviceInfo.length>1?   
        <> <ul>
          {flipDeviceInfo.map((elem: any, index: number) => {
            return (
              <div key={index}>
                {elem.device_type === config().DESK_PHONE ?
                  (<li key={index}><URCheckBoxCall onChange={() => flipDeviceChecked(elem.device_type, elem.dtmf_key)}
                    checked={(getCallWindow.isFlippedDevice === elem.device_type) ? true : false}
                    name="" ></URCheckBoxCall><b>Desk Phone</b></li>)

                  : (elem.device_type === config().UR_ANDROID ?
                    (<li key={index}><URCheckBoxCall onChange={() => flipDeviceChecked(elem.device_type, elem.dtmf_key)}
                      checked={(getCallWindow.isFlippedDevice === elem.device_type) ? true : false}
                      name=""></URCheckBoxCall><b>Android</b></li>)

                    : (elem.device_type === config().UR_IOS ?
                      (<li key={index}><URCheckBoxCall
                        onChange={() => flipDeviceChecked(elem.device_type, elem.dtmf_key)}
                        checked={(getCallWindow.isFlippedDevice === elem.device_type) ? true : false}
                        name=""></URCheckBoxCall><b>IOS</b></li>)
                      : (null)
                    )
                  )}
              </div>
            );
          })
          }
        </ul>
   <div className={styles.footersection}>
   <URButton className={styles.cancelbtn} name="Cancel" onClick={callFlip}></URButton>
   <URButton className={styles.savebtn} name="Done" onClick={callFlipped}></URButton>
 </div>
 </>

: 

<span className={styles.noDevice}>No Active devices found</span>
}
      </Modal> */}

      <Modal visible={getCallWindow.isEndModal} className={`${styles.flipcallmodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={cancelEndModal} />
        <h2>End Call?</h2>
        <span> Are you sure want to end the call?</span>
        <div className={styles.footersection}>
          <URButton className={styles.cancelbtn} name="Leave Call" onClick={beforeLeave}></URButton>
          <URButton className={styles.endAll} name="End Call for All" onClick={endAllCall}></URButton>
        </div>
      </Modal>

  <Modal visible={getCallWindow.isAddCallModal} className={`${styles.newmessage} ${"modaloverwrite"} ${"taskcreation"} `}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={addCallClose} />
        <h2> Audio Call <span className={styles.userCountno}>({getCallWindow.totalPart.length}/100)</span></h2>
        <div className={styles.rightsidebar}>
          <div className={styles.middlelayers}>

            <label>Contact</label>
            <div className={styles.insideicon}>
              <Select
                mode="multiple"
                style={{ width: '100%' }}
                /*  optionLabelProp="label" */
                filterOption={false}
                showSearch={true}
                value={getCallWindow.chooseAddCallPart}
                defaultValue={getCallWindow.chooseAddCallPart}
                onSearch={searchAddCall}
                placeholder="Enter name or extension"
                className="newselects"
                onChange={changePart}
              >
                {MemberLists(searchText, getCallWindow.allCon, true)}
              </Select>
            </div>

            <label>Phone Number</label>
            {/* <URInput placeHolder="Type numbers separated by space" name="" value={phoneNum} className={`hoverbdrBlue  ${styles.normalinput}`}  onChange={handleNumbers} />    */}
            <Select
              mode="tags"
              style={{ width: '100%' }}
              showSearch={false}
              value={getCallWindow.phNum}
              // labelInValue
              placeholder="Type numbers separated by space"
              className="newselects"
              // className={`hoverbdrBlue  ${styles.normalinput}`}
              onChange={handleNumbers}
              tokenSeparators={[' ', ',']}
              filterOption={false}
            // inputValue={'numbers'}
            // defaultValue={''}
            //disabled
            >
            </Select>

          </div>
        </div>
        <div className={`${styles.footersection} ${"footersection"} padlrzero `}>
          <URButton className="urButton buttonWhite " name="Cancel" onClick={addCallClose}></URButton>
          <URButton className={`${(getCallWindow.chooseAddCallPart.length > 0 ||getCallWindow.phNum>0)? "urButton buttonBlue marlftmin" : 
          "urButton buttonBlue disabled hidecursor"}`}  onClick={startTeamCall} name="Start"></URButton>
            
        </div>
      </Modal>

      <Modal visible={getCallWindow.isAssignModal} className={`${styles.flipcallmodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={closeAssign} />
        <h2>Assign Host</h2>
        {/* <span> Are you sure want to end the call?</span> */}

        <div className={styles.insideicon}>
              <Select
                style={{ width: '100%' }}
                /*  optionLabelProp="label" */
                filterOption={false}
                showSearch={true}
                value={chooseParticipants}
                defaultValue={chooseParticipants}
                onSearch={searchContact}
                placeholder="Enter name or extension"
                className="newselects"
                onChange={change}
              >
                {SpecificMemberLists(searchText,allContacts, true)}

                
              </Select>
            </div>
        <div className={styles.footersection}> 
          <URButton className={styles.cancelbtn} name="Cancel" onClick={closeAssign}></URButton>
          <URButton className={styles.endAll} name="Assign and Leave" onClick={assigNleave}></URButton>
        </div>
      </Modal>



      
    </>
  );
};

